import { DataTypeColumn } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

// Column definitions for Variant Search Table
// Used for filter titles and column metadata

export const VARIANTS_COLUMNS = {
  // Display columns
  name: {
    header: 'Variant Name',
    group: 'Variant Details',
  },
  product_name: {
    header: 'Product',
    group: 'Variant Details',
  },
  sku: {
    header: 'SKU',
    group: 'Variant Details',
  },
  gtin: {
    header: 'UPC',
    group: 'Variant Details',
  },

  // Filter fields
  match_status: {
    header: 'Product Link Status',
    group: 'Status',
  },
  product: {
    header: 'Product',
    group: 'Filters',
  },
  created: {
    header: 'Created Date',
    group: 'Activity',
  },
  modified: {
    header: 'Modified Date',
    group: 'Activity',
  },
} satisfies Record<string, DataTypeColumn>
